import type { NetworkStatus } from "./types";

export function networkReadinessHeading(network: NetworkStatus): string {
  return network.phone_access_ready
    ? "iPhone access is ready on this Wi-Fi"
    : "This network needs attention";
}

export function isHostedBaseUrl(baseUrl: string): boolean {
  try {
    const url = new URL(baseUrl);
    const host = url.hostname.toLowerCase();
    const isPrivateIpv4 =
      /^10\./.test(host) ||
      /^192\.168\./.test(host) ||
      /^172\.(1[6-9]|2\d|3[01])\./.test(host);
    const isLocalHost =
      host === "localhost" ||
      host === "127.0.0.1" ||
      host === "::1" ||
      host.endsWith(".local");
    return url.protocol === "https:" && !isPrivateIpv4 && !isLocalHost;
  } catch {
    return false;
  }
}
